import { useQuery } from '@office-start/data-fetching';
import { resolveFirstRunConfig } from '../resolveFirstRunConfig';
export function useFirstRunConfig(OEMCode, isSecondRun) {
    if (OEMCode === void 0) { OEMCode = ''; }
    var query = ['FirstRunConfig'];
    return useQuery(query, function () { return resolveFirstRunConfig(isSecondRun); }, {
        staleTime: Infinity,
        cacheTime: Infinity,
    });
}
//# sourceMappingURL=useFirstRunConfig.js.map